import gql from 'graphql-tag';

export const SpaceRestrictionCheckQuery = gql`
	query SpaceRestrictionCheckQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			settings {
				routeOverrideEnabled
			}
		}
	}
`;
